// ─── Configuración central de agenda ─────────────────────────────────────────
// Modifica aquí los días y horarios permitidos para TODA la aplicación.

export const SCHEDULE_CONFIG = {
  // 0=Dom, 1=Lun, 2=Mar, 3=Mié, 4=Jue, 5=Vie, 6=Sáb
  allowedDays: [1, 2, 3, 4, 5, 6], // Lunes a Sábado
  startHour: 8,   // 08:00
  endHour: 18,    // 18:00 (última cita a las 17:59)
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
};

/**
 * Valida si una fecha y hora están dentro del horario laboral configurado.
 * @param {string} dateStr  — "YYYY-MM-DD"
 * @param {string} timeStr  — "HH:MM" (24h)
 * @returns {{ valid: boolean, error?: string }}
 */
export function validateAppointmentSchedule(dateStr, timeStr) {
  if (!dateStr) return { valid: false, error: 'La fecha es requerida.' };
  if (!timeStr) return { valid: false, error: 'La hora es requerida.' };

  const cfg = SCHEDULE_CONFIG;

  // Parse date — use noon to avoid timezone shifts
  const date = new Date(dateStr + 'T12:00:00');
  const dayOfWeek = date?.getDay();

  if (!cfg?.allowedDays?.includes(dayOfWeek)) {
    const allowedNames = cfg?.allowedDays?.map(d => cfg?.dayNames?.[d])?.join(', ');
    return {
      valid: false,
      error: `No se permiten citas los ${cfg?.dayNames?.[dayOfWeek]}. Días permitidos: ${allowedNames}.`,
    };
  }

  // Parse time
  const [hourStr, minuteStr] = timeStr?.split(':');
  const hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr || '0', 10);

  if (isNaN(hour) || isNaN(minute)) {
    return { valid: false, error: 'Formato de hora inválido.' };
  }

  const totalMinutes = hour * 60 + minute;
  const startMinutes = cfg?.startHour * 60;
  const endMinutes = cfg?.endHour * 60;

  if (totalMinutes < startMinutes || totalMinutes >= endMinutes) {
    return {
      valid: false,
      error: `Horario no permitido. Las citas deben ser entre ${cfg?.startHour}:00 y ${cfg?.endHour}:00.`,
    };
  }

  return { valid: true };
}
